import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const LoadingSpinner = styled(LoadingOutlined)`
    font-size: 24;
    color: #fff;
`;

const LocalSpin = styled(Spin)`
    poistion: absolute;
`;

export const ButtonAsync = ({ style, disabled, onClick, onSuccess, onError, buttonText, id }) => {
    const [spin, setSpin] = useState();

    const handleClick = async () => {
        setSpin(true);
        try {
            const data = onClick ? await onClick() : null;

            if (onSuccess) onSuccess(data);
        } catch (err) {
            if (onError) onError(err);
        }
        setTimeout(() => setSpin(false), 1000);
    };

    return (
        <Button id={id} style={style} disabled={disabled} onClick={handleClick}>
            {spin ? <LocalSpin indicator={<LoadingSpinner />} /> : buttonText || 'Next'}
        </Button>
    );
};

export const IconWrapper = styled.div`
    float: right;
    display: flex;
`;

export const Input = styled.input`
    background: #f5f5f5;
    border-radius: 6px;
    border: none;
    outline: none;
    height: 30px;
    width: 100%;
    color: black;
    padding: 0px 10px;
    ${(props) =>
        props.disabled &&
        css`
            color: grey;
        `};
`;

export const Title = styled.div`
    font-size: 16px;
    color: black;
`;

export const Text = styled.div`
    font-size: 12px;
    color: black;
    overflow-wrap: break-word;
    ${(props) =>
        props.required &&
        css`
            :after {
                content: ' *';
                color: red;
            }
        `}
    ${(props) =>
        props.disabled &&
        css`
            color: grey;
        `}
`;

export const Container = styled.div`
    width: 900px;
    padding: 20px;
    background: #ffffff;
    ${(props) =>
        props.complete === false &&
        css`
            box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
        `}
    border-radius: 12px;
    margin-bottom: 12px;
    position: relative;
`;

export const TitleWrapper = styled(Title)`
    overflow: auto;
    line-height: 30px;
    ${(props) =>
        props.complete &&
        css`
            :after {
                content: ' - COMPLETED';
            }
        `}
    ${(props) =>
        props.complete === null &&
        css`
            :after {
                content: ' - IN PROGRESS';
            }
        `}
`;

export const BoxWrapper = styled.div`
    ${(props) =>
        props.complete || props.complete === null
            ? css`
                  display: none;
              `
            : css`
                  display: block;
                  margin-top: 20px;
              `}
`;

export const Button = styled.button`
    ${(props) =>
        props.disabled
            ? css`
                  background: #e0e0e0;
                  border: #e0e0e0;
                  color: #707070;
                  cursor: not-allowed;
              `
            : css`
                  background: #6347ff;
                  border: #6347ff;
                  color: #fff;
              `}
    border-radius: 6px;
    width: 96px;
    height: 30px;
    outline: none;
    font-weight: 500;
    font-size: 14px;
    line-height: 15px;
    :hover {
        ${(props) =>
            !props.disabled &&
            css`
                cursor: pointer;
                background: #7f68ff;
            `}
    }
`;

export const PreFilledText = styled.div`
    font-size: 12px;
    color: grey;
`;

export const IconWithText = ({ id, icon, text, disabled, textColor, ...restProps }) => {
    const PContainer = styled.div`
        display: flex;
        :hover {
            ${disabled
                ? css`
                      cursor: not-allowed;
                  `
                : css`
                      cursor: pointer;
                  `}
        }
    `;

    const PText = styled(Text)`
        display: inline-block;
        line-height: 20px;
        margin-left: 6px;
        margin-right: 16px;
        color: ${textColor || '#6347ff'};
    `;

    return (
        <PContainer id={id} {...restProps}>
            {icon}
            <PText>{text}</PText>
        </PContainer>
    );
};
